import { z } from "zod";
import { npdIngredientWithMixtureIdDtoSchema } from "../npd-ingredient/npd-ingredient-with-mixture-id.schema";
import { npdSettingsDtoSchema } from "../npd-settings";
export const npdFormulationDtoSchema = z.object({
    ingredients: z.array(npdIngredientWithMixtureIdDtoSchema),
    settings: npdSettingsDtoSchema,
});
